<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">
            {{ $route.meta.title }}
          </h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-dropdown
              v-if="canUserResendEmail"
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="status"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-send"></i>
                <strong class="d-lg-block d-none">Send Email</strong>
              </base-button>

              <div
                class="dropdown-item"
                @click="sendConfirmation()"
                v-if="!customer.status && customerStatus"
              >
                <span class="icon-action">
                  Confirmation Account
                </span>
              </div>

              <div class="dropdown-item" @click="sendEmailPassword()">
                <span class="icon-action">
                  Password Recovery
                </span>
              </div>
            </base-dropdown>

            <base-button
              type="outline-neutral"
              class="min-button ml-2 no-mb"
              @click="mode = 'view'"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              v-if="canUserUpdate && mode === 'view'"
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button no-mb ml-2"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              v-if="canUserUpdate && mode === 'edit'"
              type="primary"
              class="min-button no-mb ml-2"
              @click="saveCustomer()"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row justify-content-center">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>
                    </div>

                    <div class="box-profile-one">
                      <h2
                        class="subtitle mb-1"
                        v-if="['business', 'travel_agency'].includes(type)"
                      >
                        {{ customer.company_name }}
                      </h2>
                      <h2 class="subtitle capitalize mb-1" v-else>
                        {{ customer.first_name }}
                        {{ customer.last_name }}
                      </h2>

                      <div class="role mb-0 capitalize">
                        {{ type }}
                      </div>
                    </div>

                    <div class="d-inline-block mt-2 mb-3">
                      <div
                        class="badge-profile status-confirmed"
                        v-if="customer.status && customerStatus"
                      >
                        <i class="flaticon-check-2 text-success f25 mr-2"></i>
                        <span>Confirmed</span>
                      </div>

                      <div
                        class="badge-profile status-cancelled "
                        v-if="!customer.status && customerStatus"
                      >
                        <i class="flaticon-check-2 text-danger f25 mr-2"></i>
                        <span>No Confirmed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card ">
                <h2 class="subtitle">Markup</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="data-block" v-if="mode === 'view'">
                      <span class="content-block" v-if="customer.mark_up"
                        >{{ customer.mark_up }}%</span
                      >
                      <span class="content-block" v-else>0</span>
                    </div>

                    <div class="mb-4 " v-if="mode === 'edit'">
                      <BaseNumberInput
                        v-model.number="$v.customer.mark_up.$model"
                        label="Markup"
                        placeholder="Markup"
                        id="customer_markup"
                        name="customer_markup"
                        maxlength="3"
                        tabindex="17"
                        class="input-append"
                        @input="validateMarkup"
                        markrequired
                        :error="
                          !$v.customer.mark_up.between
                            ? `Enter from ${$v.customer.mark_up.$params.between.min} to ${$v.customer.mark_up.$params.between.max}`
                            : ''
                        "
                      >
                        <template slot="append">%</template>
                      </BaseNumberInput>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
              <div class="card ">
                <h2 class="subtitle">Notes</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="data-block" v-if="mode === 'view'">
                      <span class="content-block" v-if="customer.notes">{{
                        customer.notes
                      }}</span>
                      <span class="content-block" v-else>No notes here</span>
                    </div>

                    <div class="mb-4 " v-if="mode === 'edit'">
                      <el-input
                        v-model="$v.customer.notes.$model"
                        placeholder="Special Requirements"
                        id="customer_notes"
                        name="customer_notes"
                        tabindex="23"
                        maxlength="200"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-12 col-md-12">
          <div class="card" v-if="mode === 'edit'">
            <h2 class="subtitle">
              Customer Type
            </h2>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
                <div
                  class="option-transfers d-xl-block d-lg-block d-md-block d-sm-block d-none"
                >
                  <b-form-radio-group
                    id="btn-radios-1"
                    v-model="type"
                    :options="typeOptions"
                    name="radios-btn-default"
                    buttons
                    @change="changeTypeCustomer"
                    value-field="value"
                    text-field="label"
                    button-variant="group-neutral"
                    tabindex="1"
                    class="buttons-type"
                  ></b-form-radio-group>
                </div>

                <div
                  class="d-xl-none d-lg-none d-md-none d-sm-none d-block mt-2"
                >
                  <WSelect
                    id="typeCustomer"
                    name="typeCustomer"
                    placeholder="Type"
                    v-model="type"
                    label="Type"
                    class="mb-0"
                    markrequired
                  >
                    <el-option
                      v-for="option in typeOptions"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </WSelect>
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-if="['business', 'travel_agency'].includes(type)">
            <h2 class="subtitle">
              Business Details
            </h2>
            <div v-if="mode === 'view'">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Business Name</span>
                      <span class="content-block">{{
                        customer.company_name
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="customer.vat_number"
                  >
                    <div class="data-block">
                      <span class="title-block">VAT Number</span>
                      <span class="content-block">{{
                        customer.vat_number
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2" v-if="mode === 'edit'">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model.trim="$v.customer.company_name.$model"
                      label="Business Name"
                      placeholder="Business Name"
                      id="bussiness_name"
                      name="bussiness_name"
                      markrequired
                      tabindex="1"
                      maxlength="45"
                      :error="
                        !$v.customer.company_name.minLength ||
                        $v.customer.company_name.$error
                          ? `Enter from ${$v.customer.company_name.$params.minLength.min} to ${$v.customer.company_name.$params.maxLength.max} letters.`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model.trim="$v.customer.vat_number.$model"
                      label="VAT Number"
                      placeholder="VAT Number"
                      id="bussiness_VatNumber"
                      name="bussiness_VatNumber"
                      tabindex="2"
                      maxlength="45"
                      :error="
                        !$v.customer.vat_number.minLength
                          ? `Enter from ${$v.customer.vat_number.$params.minLength.min} to ${$v.customer.vat_number.$params.maxLength.max} characters.`
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle">Main Contact</h2>

            <div v-if="mode === 'view'">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Full Name</span>
                      <span class="content-block capitalize "
                        >{{ customer.first_name }}
                        {{ customer.last_name }}</span
                      >
                    </div>
                  </div>
                  <div
                    class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="customer.gender"
                  >
                    <div class="data-block">
                      <span class="title-block">Gender</span>
                      <span class="content-block">{{
                        getGender(customer.gender)
                      }}</span>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Contact Number</span>
                      <span class="content-block">
                        <a :href="`tel:${customer.phone}`">{{
                          customer.phone
                        }}</a>
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="customer.phone"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="customer.other_contact_platform"
                  >
                    <div class="data-block">
                      <span class="title-block">Other Contact Info</span>
                      <span class="content-block">
                        <i
                          class="flaticon-bold-whatsapp f16 mr-1"
                          v-if="customer.other_contact_platform === 'Whatsapp'"
                        ></i>
                        <i
                          class="flaticon-bold-logotipo-de-skype f16 mr-1"
                          v-if="customer.other_contact_platform === 'Skype'"
                        ></i>

                        {{ customer.other_contact_platform }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2" v-if="mode === 'edit'">
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model.trim="$v.customer.first_name.$model"
                  label="First Name"
                  placeholder="First Name"
                  id="first_name"
                  name="first_name"
                  maxlength="45"
                  tabindex="1"
                  format="capitalize"
                  :focusact="true"
                  markrequired
                  :error="
                    !$v.customer.first_name.minLength ||
                    $v.customer.first_name.$error
                      ? `Enter from ${$v.customer.first_name.$params.minLength.min} to ${$v.customer.first_name.$params.maxLength.max} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model.trim="$v.customer.last_name.$model"
                  label="Last Name"
                  placeholder="Last Name"
                  id="last_name"
                  name="last_name"
                  maxlength="45"
                  tabindex="2"
                  format="capitalize"
                  markrequired
                  :error="
                    !$v.customer.last_name.minLength ||
                    $v.customer.last_name.$error
                      ? `Enter from ${$v.customer.last_name.$params.minLength.min} to ${$v.customer.last_name.$params.maxLength.max} letters.`
                      : ''
                  "
                />
              </div>
              <div
                class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 form-group mb-4"
                v-bind:class="{
                  'is-invalid': $v.customer.gender.$error
                }"
              >
                <label for="title" class="title-label">Gender</label>
                <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                  <b-form-radio-group
                    v-model="$v.customer.gender.$model"
                    :aria-describedby="ariaDescribedby"
                    id="radio-gender"
                    name="radio-gender"
                    buttons
                    button-variant="outline-neutral"
                    size="md"
                    tabindex="3"
                  >
                    <b-form-radio value="male" class="pc-3" tabindex="3"
                      >Mr.</b-form-radio
                    >
                    <b-form-radio value="female" class="pc-3"
                      >Mrs.</b-form-radio
                    >
                    <b-form-radio value="other" class="pc-3">Mx.</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>

                <small
                  class="invalid-feedback mt-1"
                  v-if="$v.customer.gender.$error"
                  >Select</small
                >
              </div>

              <div
                class="col-xl-3 col-lg-4 col-md-3 col-sm-4 col-12"
                v-if="type === 'customer'"
              >
                <base-input label="Date of Birth">
                  <flat-picker
                    v-model="$v.customer.date_of_birth.$model"
                    placeholder="-"
                    id="date"
                    name="customer_birth"
                    tabindex="4"
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur"
                    :config="{
                      altFormat: 'd-M-Y',
                      altInput: true,
                      dateFormat: 'Y-m-d',
                      allowInput: true
                    }"
                    class="input-custom"
                  ></flat-picker>
                </base-input>
              </div>

              <div
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12"
                v-if="type === 'customer'"
              >
                <base-input
                  v-model.trim="$v.customer.goverment_id.$model"
                  label="Goverment ID"
                  placeholder="Goverment ID"
                  id="goverment_id"
                  name="goverment_id"
                  maxlength="45"
                  tabindex="5"
                  :error="
                    !$v.customer.goverment_id.minLength
                      ? `Enter from ${$v.customer.goverment_id.$params.minLength.min} to ${$v.customer.goverment_id.$params.maxLength.max} characters.`
                      : ''
                  "
                />
              </div>

              <div
                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 inputphone form-group"
              >
                <label
                  class="title-label"
                  v-bind:class="{
                    'is-invalid': $v.customer.phone.$error
                  }"
                  ><span class="markrequired">*</span>Contact Number</label
                >
                <vue-tel-input
                  mode="international"
                  inputClasses="input no-label no-err"
                  v-model="phone_format"
                  key="NumberPhoneCustomer"
                  inputId="NumberPhoneCustomer"
                  name="NumberPhoneCustomer"
                  :dynamicPlaceholder="true"
                  :disabledFetchingCountry="true"
                  :validCharactersOnly="true"
                  :wrapperClasses="[
                    $v.customer.phone.$error ? 'is-invalid' : '',
                    'mb-0'
                  ]"
                  @validate="validatePhoneInput"
                  tabindex="6"
                ></vue-tel-input>
                <small
                  class="invalid-feedback mt-1"
                  v-if="$v.customer.phone.$error"
                  >Enter a valid Phone Number</small
                >
              </div>

              <div class="col-xl-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <label class="title-label">Other Contact Info</label>
                <div class="d-flex">
                  <b-form-group
                    v-slot="{ ariaDescribedby2 }"
                    class="d-inline-flex"
                  >
                    <b-form-radio-group
                      v-model="customer.other_contact_platform"
                      :aria-describedby="ariaDescribedby2"
                      id="radio-contact"
                      name="radio-contact"
                      tabindex="7"
                      buttons
                      button-variant="outline-neutral"
                      size="md"
                    >
                      <b-form-radio
                        value="Whatsapp"
                        class="pc-2"
                        title="Whatsapp"
                        tabindex="7"
                        ><i class="flaticon-bold-whatsapp f16"></i
                      ></b-form-radio>
                      <b-form-radio value="Skype" class="pc-2" title="Skype"
                        ><i class="flaticon-bold-logotipo-de-skype f16"></i
                      ></b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>

                  <base-input
                    v-model.trim="customer.contact_info"
                    placeholder="Other Contact Info"
                    id="passengers_phone_optional"
                    name="passengers_phone_optional"
                    tabindex="8"
                    class="d-inline-flex"
                  >
                  </base-input>
                </div>
              </div>
            </div>
          </div>

          <div class="card  ">
            <h2 class="subtitle">Account Info</h2>
            <div class="">
              <div class="col-xl-12">
                <div class="row" v-show="mode === 'view'">
                  <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Email Address</span>
                      <span class="content-block">
                        <a
                          :href="
                            `https://mail.google.com/mail/?view=cm&fs=1&to=${customer.email}`
                          "
                          target="_blank"
                          >{{ customer.email }}</a
                        >
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="customer.email"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Register Source</span>
                      <span class="content-block">{{ source }}</span>
                    </div>
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Register Date/Time</span>
                      <span class="content-block">{{ created }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2" v-show="mode === 'edit'">
              <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                <base-input
                  label="Email Address"
                  placeholder="Email Address"
                  id="customer_email"
                  name="customer_email"
                  maxlength="100"
                  tabindex="14"
                  format="lowercase"
                  autocomplete="off"
                  markrequired
                  v-model.trim="$v.customer.email.$model"
                  :error="getEmailValidationMessage($v.customer.email)"
                />
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                <div class="data-block">
                  <span class="title-block">Register Source</span>
                  <span class="content-block">{{ source }}</span>
                </div>
              </div>

              <div class="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12">
                <div class="data-block">
                  <span class="title-block">Register Date/Time</span>
                  <span class="content-block">{{ created }}</span>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model="$v.customer.password.$model"
                  label="Password"
                  placeholder="Password"
                  id="password"
                  name="password"
                  maxlength="20"
                  tabindex="15"
                  class="input-append mb-0"
                  markrequired
                  v-bind:class="{
                    'is-invalid': $v.customer.password.$error
                  }"
                  :type="typePassword"
                  autocomplete="new-password"
                  :tooltip="true"
                  titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                  contentTooltip='<ul class="ul-pop">
                                  <li>Enter from 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                  ><template slot="append">
                    <span @click="seePassword()" class="icon-button"
                      ><i
                        v-bind:class="{
                          'flaticon-view-1': typePassword == 'password',
                          'flaticon-hidden': typePassword == 'text'
                        }"
                      ></i
                    ></span>
                  </template>
                </base-input>
                <small
                  class="invalid-feedback mt-0"
                  v-if="$v.customer.password.$error"
                  >{{
                    validatePassword(
                      $v.customer.password.minLength,
                      $v.customer.password.$error,
                      $v.customer.password.$params,
                      $v.customer.password.$model,
                      $v.customer.password.required
                    )
                  }}</small
                >
                <small
                  class="valid-feedback mt-0"
                  v-if="
                    $v.customer.password.strongPassword &&
                      $v.customer.password.$model.length > 0
                  "
                  >Strong Password</small
                >
              </div>

              <div
                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mt-sm-0 mt-4"
              >
                <base-input
                  v-model.trim="$v.repeatPassword.$model"
                  label="Confirm Password"
                  placeholder="Confirm Password "
                  type="password"
                  id="confirm_password"
                  name="confirm_password"
                  maxlength="20"
                  tabindex="16"
                  :error="
                    !$v.repeatPassword.sameAsPassword ||
                    $v.repeatPassword.$error
                      ? `Passwords must be identical.`
                      : ''
                  "
                />
              </div>

              <div
                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12  form-group alinmov1"
              >
                <base-button
                  type="outline-secondary"
                  class="min-button"
                  @click="autogeneratePass()"
                >
                  <i class="flaticon-bold-lock"></i>Generate Password
                </base-button>

                <base-button
                  type="outline-secondary"
                  class="min-button"
                  v-clipboard:copy="$v.customer.password.$model"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onErrorCopy"
                  v-if="customer.password"
                >
                  <i class="flaticon-copy link ml-0"></i>Copy Password
                </base-button>
              </div>
            </div>
          </div>

          <div class="card">
            <h2 class="subtitle">Address</h2>

            <div class="col-xl-12" v-if="mode === 'view'">
              <div
                class="row"
                v-if="
                  customer.street ||
                    customer.city ||
                    customer.state ||
                    customer.zip_code ||
                    customer.country
                "
              >
                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.street"
                >
                  <div class="data-block">
                    <span class="title-block"
                      >Street address, apartment, suite, etc.:</span
                    >
                    <span class="content-block">{{ customer.street }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.city"
                >
                  <div class="data-block">
                    <span class="title-block">City</span>
                    <span class="content-block capitalize">{{
                      customer.city
                    }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.state"
                >
                  <div class="data-block">
                    <span class="title-block">State/Province/Region</span>
                    <span class="content-block">{{ customer.state }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.zip_code"
                >
                  <div class="data-block">
                    <span class="title-block">Zip/Postal Code</span>
                    <span class="content-block">{{ customer.zip_code }}</span>
                  </div>
                </div>

                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                  v-if="customer.country"
                >
                  <div class="data-block">
                    <span class="title-block">Country</span>
                    <span class="content-block">{{ customer.country }}</span>
                  </div>
                </div>
              </div>

              <div class="row" v-else>
                <div class="col-12">
                  <div class="data-block">
                    <span class="content-block">No Provided</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2" v-if="mode === 'edit'">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model="$v.customer.street.$model"
                  label="Street address, apartment, suite, etc."
                  placeholder="Street address, apartment, suite, etc"
                  id="customer_street"
                  name="customer_street"
                  maxlength="200"
                  tabindex="9"
                  format="capitalize"
                  :error="
                    !$v.customer.street.minLength || $v.customer.street.$error
                      ? `Enter from ${$v.customer.street.$params.minLength.min} to ${$v.customer.street.$params.maxLength.max} characters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model="$v.customer.city.$model"
                  label="City"
                  placeholder="City"
                  id="customer_city"
                  name="customer_city"
                  maxlength="45"
                  tabindex="10"
                  format="capitalize"
                  :error="
                    !$v.customer.city.minLength || $v.customer.city.$error
                      ? `Enter from ${$v.customer.city.$params.minLength.min} to ${$v.customer.city.$params.maxLength.max} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model="$v.customer.state.$model"
                  label="State/Province/Region"
                  placeholder="State/Province/Region"
                  id="customer_state"
                  name="customer_state"
                  maxlength="45"
                  f
                  tabindex="11"
                  format="capitalize"
                  :error="
                    !$v.customer.state.minLength || $v.customer.state.$error
                      ? `Enter from ${$v.customer.state.$params.minLength.min} to ${$v.customer.state.$params.maxLength.max} letters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model.trim="$v.customer.zip_code.$model"
                  label="Zip/Postal Code"
                  placeholder="Zip/Postal Code"
                  id="customer_zipcode"
                  name="customer_zipcode"
                  maxlength="45"
                  tabindex="12"
                  :error="
                    !$v.customer.zip_code.minLength ||
                    $v.customer.zip_code.$error
                      ? `Enter from ${$v.customer.zip_code.$params.minLength.min} to ${$v.customer.zip_code.$params.maxLength.max} characters.`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                <WSelect
                  v-bind:class="{
                    'invalid-feedback': $v.customer.country.$error
                  }"
                  v-model="$v.customer.country.$model"
                  label="Country"
                  placeholder="Enter a Country"
                  id="customer_country"
                  name="customer_country"
                  tabindex="13"
                  remote
                  filterable
                  reserve-keyword
                  :remote-method="remoteMethod"
                  :loading="loading"
                  clearable
                >
                  <el-option
                    v-for="country in options"
                    :value="country.name"
                    :label="country.name"
                    :key="country.name"
                  ></el-option>
                </WSelect>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapMutations } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  numeric,
  minValue,
  requiredIf,
  decimal,
  between,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { CustomersAPI, AuthAPI } from "../../../core/api";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import moment from "moment-timezone";
import lodash from "lodash";
import generator from "generate-password";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditCustomers",
  data() {
    return {
      customer: {
        type: "customer",
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        password: "",
        phone: "",
        contact_info: "",
        goverment_id: "",
        gender: "other",
        date_of_birth: "",
        country: "",
        city: "",
        state: "",
        zip_code: "",
        street: "",
        notes: "",
        company_name: "",
        type_markup: "markup",
        type_charge: "net_price",
        vat_number: "",
        mark_up: 0,
        vip: false,
        session: false,
        status: false,
        relationship: {
          owner: "",
          type: "admin"
        },
        other_contact_platform: "",
        source: "rhomtrip"
      },
      loading: false,
      options: [],
      type: "customer",
      phone_format: "",
      repeatPassword: "",
      genderOptions: [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" }
      ],
      typeOptions: [
        { value: "customer", label: "Customer" },
        { value: "business", label: "Business" },
        { value: "guest", label: "Guest" }
      ],
      saved: false,
      lastEmail: "",
      contact_platform: [
        { value: "Whatsapp", label: "Whatsapp" },
        { value: "Skype", label: "Skype" }
      ],
      typePassword: "password",
      coins: [
        { code: "USD", symbol: "$", label: "US Dollar" },
        { code: "EUR", symbol: "€", label: "Euro" },
        { code: "GBP", symbol: "£", label: "British Pound" },
        { code: "CHF", symbol: "₣", label: "Swiss Franc" },
        { code: "DKK", symbol: "kr", label: "Denmark Krone" },
        { code: "SEK", symbol: "kr", label: "Swedish Krona" },
        { code: "NOK", symbol: "kr", label: "Norwegian Krone" },
        { code: "ISK", symbol: "kr", label: "Icelandic Króna" },
        { code: "AED", symbol: "د.إ", label: "United Arab Emirates Dirham" }
      ],
      customerCopy: {},
      created: "",
      showPass: false,
      source: "rhombuss",
      customerId: "",
      customerStatus: false,
      mode: "view",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png")
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Customers",
        to: "/customers"
      },

      {
        text: "Customer Profile",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.customerId = this.$route.params.id;
    await this.getCustomer(this.customerId);
  },
  watch: {
    "customer.password": {
      handler: function(current, old) {
        this.customer.session = current ? true : false;
        this.customer.status = current ? true : false;
      },
      deep: true
    }
  },
  methods: {
    async getCustomer(customerId) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.getCustomerById(customerId);
        this.setLoad(false);
        if (data.status) {
          let customer = data.data;
          this.type = customer.type;
          this.customer.first_name = customer.first_name;
          this.customer.last_name = customer.last_name;
          this.customer.company_name = customer.company_name;
          this.customer.vat_number = customer.vat_number;
          this.$v.customer.email.$model = customer.email;
          this.lastEmail = this.customer.email;
          this.customer.type_markup = customer.type_markup;
          this.customer.phone = customer.phone;
          this.phone_format = `${this.customer.phone}`;
          this.customer.goverment_id = customer.goverment_id;
          this.customer.gender = customer.gender;
          this.customer.date_of_birth = customer.date_of_birth;
          this.customer.country = customer.country;
          this.customer.city = customer.city;
          this.customer.state = customer.state;
          this.customer.zip_code = customer.zip_code;
          this.customer.street = customer.street;
          this.customer.notes = customer.notes;
          this.customer.mark_up = customer.mark_up;
          this.customer.type_charge = customer.type_charge;
          this.customer.vip = customer.vip;
          this.customer.type = customer.type;
          this.customer.relationship = lodash.cloneDeep(customer.relationship);
          this.customer.other_contact_platform =
            customer.other_contact_platform;
          this.customer.contact_info = customer.contact_info;

          this.customer.session = customer.session;
          this.customer.status = customer.status;
          this.customer.source = customer.source;
          this.source =
            ["rhomtrip", "rhombuss"].indexOf(customer.source) > -1
              ? "RhomTrip"
              : "Web";
          this.customerStatus = true;
          this.created = moment(customer.created_at).format(
            "DD MMM. YYYY - hh:mm A"
          );
          this.customerCopy = lodash.cloneDeep(this.customer);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error loading the Customer, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error loading the Customer, please try again"
        );
      }
    },
    async saveCustomer(route = null) {
      try {
        if (!this.$v.customer.$invalid) {
          var customer = lodash.cloneDeep(this.customer);
          customer.full_name = `${customer.first_name} ${customer.last_name}`;
          customer.email = customer.email.toLowerCase();
          await this.updateCustomer(this.$route.params.id, customer, route);
        } else {
          this.$v.customer.$touch();
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error updating the Customer, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateCustomer(customerId, customer, route = null) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.updateCustomerById(
          customerId,
          customer
        );
        this.setLoad(false);
        this.saved = true;
        if (data.data !== null) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Customer has been updated",
            icon: "flaticon-check-3"
          });
          this.$router.push(route ? route : "/customers");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error updating the Customer, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error updating the Customer, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    validatePhoneInput(payload) {
      let result = payload;
      if (result.isValid) {
        this.customer.phone = result.number.e164;
      } else {
        this.customer.phone = "";
      }
    },
    remoteMethod(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.options = [];
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    validatePassword($minLength, $error, $params, $model, $strongPassword) {
      if (!$minLength) {
        return `Password must have at least ${$params.minLength.min} letters.`;
      } else if (!$strongPassword && $model.length > 0) {
        return "Invalid password";
      } else {
        return "";
      }
    },
    validateMarkup(value) {
      if (parseFloat(value) < 0) {
        this.customer.mark_up = 0;
      }
    },
    getOwner() {
      return this.sesion.role === this.sesion.account_type.type
        ? this.sesion.id
        : this.sesion.account_type.owner;
    },
    autogeneratePass() {
      var password = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      });
      this.customer.password = password;
      this.repeatPassword = password;
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The data has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The data couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    seePassword() {
      this.typePassword = this.typePassword == "password" ? "text" : "password";
    },
    async sendEmailConfirmationToCostumer(customerId, email) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.sendEmailToConfirmAccount(
          customerId,
          email,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been send",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The email can't be send!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async sendConfirmation() {
      if (this.customer.type !== "guest") {
        let { value } = await Swal.fire({
          title: "Account Confirmation Email",
          html:
            "Are you sure you want to <strong>Send</strong> an account confirmation email?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.sendEmailConfirmationToCostumer(
            this.customerId,
            this.customer.email
          );
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Guest users are not allowed to login",
          icon: "flaticon-warning-1"
        });
      }
    },
    async sendEmailToRecoverPassword(customerId, email) {
      try {
        this.setLoad(true);
        let { data } = await CustomersAPI.sendEmailToRecoverPassword(
          customerId,
          email,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been sent",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The email can't be send!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async sendEmailPassword() {
      if (this.customer.type !== "guest") {
        let { value } = await Swal.fire({
          title: "Password Recovery Email",
          html:
            "Are you sure you want to <strong>send</strong> the password recovery email?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.sendEmailToRecoverPassword(
            this.customerId,
            this.customer.email
          );
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Guest users are not allowed to login",
          icon: "flaticon-warning-1"
        });
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    changeTypeCustomer(type) {
      this.$v.$reset();
      this.customer.type = type;
      if (this.customer.type === "customer") {
        this.customer.company_name = "";
      }
      this.customerCopy = lodash.cloneDeep(this.customer);
    },
    isInCustomerModule(modules = []) {
      if (!(modules.indexOf("customers") > -1)) {
        this.setCustomerSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(from, to, next) {
      let isEqual = lodash.isEqual(this.customer, this.customerCopy);
      if (!isEqual && !this.saved && this.canUserUpdate) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Customer has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveCustomer(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    getEmailValidationMessage(email) {
      if (email.$error) {
        if (!email.required) {
          return "Enter a valid email";
        } else if (!email.email) {
          return "Email is invalid";
        } else if (!email.customValidator) {
          return "Email is already used.";
        }
      } else {
        return "";
      }
    },
    async verifyEmailCustomer(email) {
      try {
        if (email) {
          let { data } = await AuthAPI.checkUniqueEmail(email.toLowerCase());
          if (data.status) {
            return !data.data.status;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    getGender(gender) {
      if (gender === "male") {
        return "Male";
      } else if (gender == "female") {
        return "Female";
      } else {
        return "Other";
      }
    },
    ...mapMutations(["setLoad", "setItemsBread", "setCustomerSearchCriteria"])
  },
  computed: {
    ...mapGetters(["countries", "sesion", "userRole", "load"]),
    canUserUpdate() {
      return isUserAuthorized("CUSTOMERS", this.userRole, "UPDATE");
    },
    canUserResendEmail() {
      return isUserAuthorized("CUSTOMERS", this.userRole, "RESEND_EMAIL");
    }
  },
  validations() {
    return {
      customer: {
        first_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        last_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        company_name: {
          required: requiredIf(function(value) {
            return ["business"].indexOf(this.type) > -1;
          }),
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        vat_number: {
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        mark_up: {
          numeric,
          decimal,
          between: between(0, 100),
          minLength: minLength(1),
          maxLength: maxLength(2)
        },
        email: {
          required,
          email,
          customValidator: async function(value) {
            if (this.validateEmail(value)) {
              if (this.lastEmail !== value) {
                return await this.verifyEmailCustomer(value);
              } else {
                return true;
              }
            } else {
              return false;
            }
          }
        },
        goverment_id: {
          minLength: minLength(3),
          maxLength: maxLength(25)
        },
        gender: {
          required: requiredIf(function(value) {
            return this.type === "customer";
          })
        },
        phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        },
        country: {
          ValName,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        city: {
          ValName,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        state: {
          ValName,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        zip_code: {
          minLength: minLength(4),
          maxLength: maxLength(10)
        },
        street: {
          minLength: minLength(5),
          maxLength: maxLength(100)
        },
        type: {
          required
        },
        vip: {
          required
        },
        date_of_birth: {
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        notes: {
          maxLength: maxLength(200)
        },
        password: {
          minLength: minLength(8),
          strongPassword(password) {
            if (password === "") {
              return true;
            } else {
              return (
                /[a-z]/.test(password) && // checks for a-z
                /[A-Z]/.test(password) && // checks for A-Z
                /[0-9]/.test(password) && // checks for 0-9
                /\W|_/.test(password) && // checks for special char
                password.length >= 8
              );
            }
          }
        }
      },
      repeatPassword: {
        sameAsPassword: sameAs(function() {
          return this.customer.password;
        })
      }
    };
  },
  components: {
    flatPicker,
    VueTelInput,
    WSelect
  },
  beforeRouteLeave(to, from, next) {
    this.isInCustomerModule(to.meta.modules);
    this.detectChanges(from, to, next);
  }
};
</script>
